// List of status codes to exclude from logging to Sentry
export const excludedStatusCodes = [0, 404, 429, 401, 403];
